import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FormGroup } from '@angular/forms';
import {
    SharedModule,
    CustomDetailComponent,
    GetSellerDetailQuery,
} from '@vendure/admin-ui/core';
import { StoreSitesListComponent } from '../store-sites-list/store-sites-list.component';

@Component({
    selector: 'seller-store-site-detail',
    templateUrl: './seller-store-site-detail.component.html',
    styleUrls: ['./seller-store-site-detail.component.scss'],
    standalone: true,
    imports: [SharedModule, StoreSitesListComponent],
})
export class SellerStoreSiteDetailComponent implements CustomDetailComponent, OnInit {
    entity$: Observable<NonNullable<GetSellerDetailQuery['seller']>>;
    detailForm: FormGroup;
    
    sellerName: string = '';
    sellerId: string | null = null;

    ngOnInit() {
        this.entity$.subscribe(seller => {
            if (seller) {
                this.sellerName = seller.name;
                this.sellerId = seller.id;
            }
        });
    }
}

